<div class="ai-advice-modal-wrapper" [class.ai-advice-modal-wrapper--open]="isOpen">
    <!-- Backdrop -->
    <div class="ai-advice-modal-backdrop" (click)="onClose()"></div>

    <!-- Modal Container -->
    <div class="ai-advice-modal-container">
        <div class="ai-advice-modal">
            <!-- Header -->
            <div class="ai-advice-modal__header">
                <div class="ai-advice-modal__header-content">
                    <span class="ai-advice-modal__title">AI ADVICE</span>
                    <button class="ai-advice-modal__close-btn" (click)="onClose()">
                        <div class="ai-advice-modal__close-icon">
                            <img src="assets/icons/close.svg" alt="Close">
                        </div>
                    </button>
                </div>
            </div>

            <!-- Body -->
            <div class="ai-advice-modal__body">
                <div class="ai-advice-modal__content-wrapper">
                    <div class="ai-advice-modal__card">
                        <div class="ai-advice-modal__card-header">
                            <div class="ai-advice-modal__ai-identity">
                                <div class="ai-advice-modal__ai-avatar"></div>
                                <span class="ai-advice-modal__ai-name">Charles says</span>
                            </div>
                            <div class="ai-advice-modal__main-text">
                                {{ currentAdvice.mainText }}
                            </div>
                            <div class="ai-advice-modal__sub-text">
                                {{ currentAdvice.subText }}
                            </div>
                        </div>

                        <div class="ai-advice-modal__card-footer">
                            <div class="ai-advice-modal__nav-controls">
                                <button class="ai-advice-modal__nav-btn" (click)="prevAdvice()"
                                    [disabled]="currentIndex === 0">
                                    <img src="assets/icons/arrow-left.svg" alt="Previous">
                                </button>
                                <button class="ai-advice-modal__nav-btn" (click)="nextAdvice()"
                                    [disabled]="currentIndex === adviceList.length - 1">
                                    <img src="assets/icons/arrow-right.svg" alt="Next">
                                </button>
                            </div>
                            <button class="ai-advice-modal__tell-more-btn" (click)="onTellMeMore()">
                                Tell me more
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>